<template>
    <!-- Shows an external link item, used in Tweet's metada column -->
    <div class="media tweet-external-link">
        <img v-if="exturl.type === 'Link'" class="extlink-prefix-img mr-2" src="/static/images/link.svg"
             alt="External document link"/>
        <img v-else-if="exturl.type === 'Image'" class="extlink-prefix-img  mr-2" src="/static/images/picture.svg"
             alt="External image link"/>
        <img v-else class="extlink-prefix-img  mr-2" src="/static/images/play-button.svg" alt="External video link"/>
        <div class="media-body">
            <div>
                <a :href="exturl.url">{{ exturl.url }}</a>
                <div v-if="exturl.type === 'Link'">
                    <div v-for="check in exturl.checks" v-bind:key="check.text">
                        <span :class="['badge', check.badge_class]">{{ check.text }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>




    const axios = require('axios').default;
    export default {
        name: "ExternalLinkItem",
        props: {
            exturl: {
                type: Object,
                default: null
            }
        },

    }
</script>

<style scoped>

</style>
